module.exports = __webpack_public_path__ + "img/196.81bf0ed7.jpg";